//funzione per crare il drawer del menù query
import React from 'react';
import Drawer from '@material-ui/core/Drawer';
import  DrawerQueryButton from './DrawerQueryButton'
import QueryComponent from './QueryComponent'

function DrawerLeft(props) {

    const [open, setOpen] = React.useState(false);

    const handleDrawerClose = () => {
        setOpen(false);
    
    
    };

    return (
        <div className={"root"}>
            <DrawerQueryButton openMenu={setOpen} button= {props.value.buttonStyle} />
            <Drawer
                transitionDuration={500}
                className={"drawer"}
                variant="persistent"
                anchor="left"
                open={open}
                classes={{
                    paper: "drawerPaperFull",
                    }}
            >       
            <QueryComponent callback={handleDrawerClose.bind(this)} />   
            </Drawer>
        </div>
    );
}

export default (DrawerLeft)